const phoneReplace = {
    OLD_TEL_HREFS: [
        '8008635312',
        '5614686150',
        '5619335351',
    ],

    NEW_DISPLAY: '561-202-6673',
    NEW_TEL: '5612026673',

    PATTERN: /800[-.\s]?863[-.\s]?5312|561[-.\s]?468[-.\s]?6150|561[-.\s]?933[-.\s]?5351/gi,

    init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.replaceAll());
        } else {
            this.replaceAll();
        }
    },

    replaceAll() {
        this.processElement(document.body);
    },

    processElement(root) {
        const walker = document.createTreeWalker(
            root,
            NodeFilter.SHOW_TEXT,
            {
                acceptNode: (node) => {
                    const tag = node.parentElement && node.parentElement.tagName.toUpperCase();
                    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') {
                        return NodeFilter.FILTER_REJECT;
                    }
                    return NodeFilter.FILTER_ACCEPT;
                }
            }
        );

        const textNodes = [];
        let n;
        while ((n = walker.nextNode())) {
            textNodes.push(n);
        }

        textNodes.forEach(node => {
            this.PATTERN.lastIndex = 0;
            if (this.PATTERN.test(node.nodeValue)) {
                this.PATTERN.lastIndex = 0;
                node.nodeValue = node.nodeValue.replace(this.PATTERN, this.NEW_DISPLAY);
            }
        });

        root.querySelectorAll('a[href]').forEach(a => {
            const href = a.getAttribute('href');
            if (/^tel:/i.test(href)) {
                const num = href.replace(/^tel:/i, '').replace(/\D/g, '');
                if (this.OLD_TEL_HREFS.includes(num)) {
                    a.setAttribute('href', 'tel:' + this.NEW_TEL);
                }
            }
        });
    },
};

export default phoneReplace;
